<nx-pageTitle-box class="mb-3" [label]="'Tenants'" [icon]="'icon-tenant'" [iconToolTip]="'Tenants'"
  [bcRootLvlLabel]="'Einstellungen'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  label="Tenantliste">
  <ng-template nxTemplate="end">
    <input
      pInputText
      type="text"
      (input)="$any(tenantsTable).filterGlobal($event.target?.['value'], 'contains')"
      class="p-inputtext p-component p-element mr-3"
    placeholder="Tenant suchen" />
    <nx-default-button
      (click)="createTenant()"
      [style]="'light'"
      [label]="'Tenant hinzufügen'"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>

<p-table
  #tenantsTable
  [lazy]="true"
  (onLazyLoad)="loadData($any($event))"
  [value]="dataSource?.data"
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{first} - {last} von {totalRecords}"
  [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <!-- no filter -->
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          placeholder="Sortierung"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th>ID</th>
      <th>Name</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-tenant>
    <tr class="clickable" (click)="openTenant(tenant)">
      <td>{{tenant.tenantId}}</td>
      <td>{{tenant.name}}</td>
      <td class="text-right">
        <nx-default-button
          class="mr-1"
          (click)="$event.stopPropagation(); copyToClipboard(tenant.tenantId)"
          [tooltip]="'Tenant-ID kopieren'"
          [style]="'dark'"
          [icon]="'icon-copy'">
        </nx-default-button>
        <nx-default-button
        (click)="$event.stopPropagation(); tenantService.switchTenant(tenant.tenantId)"
        [label]="'wechseln'"
        [tooltip]="'Zu Tenant wechseln'"
        [style]="'dark'">
      </nx-default-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="emptyMessage">Kein Tenant gefunden.</td>
    </tr>
  </ng-template>
</p-table>

